import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-admanager',
    templateUrl: './admanager.component.html',
    styleUrls: ['./admanager.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdManagerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
